import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class NgbDatepickerI18nPolish extends NgbDatepickerI18n {
    constructor(private translate: TranslateService) {
        super();
    }

    getWeekdayShortName(weekday: number): string {
        return this.translate.instant('SHARED.DATEPICKER.weekdaysShort')[weekday - 1];
    }

    getWeekdayLabel(weekday: number): string {
        return this.getWeekdayShortName(weekday);
    }

    getMonthShortName(month: number): string {
        return this.translate.instant('SHARED.DATEPICKER.months')[month - 1].substr(0, 3);
    }

    getMonthFullName(month: number): string {
        return this.translate.instant('SHARED.DATEPICKER.months')[month - 1];
    }

    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}-${date.month}-${date.year}`;
    }
}